import React from "react";
import { Box } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";

/** The rail's width, fixed: it holds the order summary, and its rows read as a column of labels. */
const railWidth = "340px";

/**
 * The builder's two columns: the quote itself on the left, and the rail that follows the reader down
 * the page on the right. One column below `md`, where 340px beside the form would leave neither
 * enough room.
 * @param root0
 * @param root0.children
 * @param root0.rail
 * @param root0.sx
 */
export function BuilderLayout({
  children,
  rail,
  sx,
}: {
  children: React.ReactNode;
  rail: React.ReactNode;
  sx?: SxProps<Theme>;
}) {
  return (
    <Box
      sx={{
        display: "grid",
        // minmax(0, 1fr) rather than 1fr: a wide table in a section must scroll inside its own
        // column instead of pushing the rail off screen.
        gridTemplateColumns: { xs: "1fr", md: `minmax(0, 1fr) ${railWidth}` },
        gap: 3,
        // Sticky positioning needs the grid items to start at the top rather than stretch.
        alignItems: "start",
        ...sx,
      }}
    >
      {/* The spacing the portal puts between the cards of a detail page. */}
      <Box data-testid="builder-main" sx={{ display: "flex", flexDirection: "column", gap: 3, minWidth: 0 }}>
        {children}
      </Box>
      <Box
        data-testid="builder-rail"
        sx={{ position: "sticky", top: (theme) => theme.spacing(3), display: "flex", flexDirection: "column", gap: 4 }}
      >
        {rail}
      </Box>
    </Box>
  );
}
